import { DatePipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, OnDestroy, inject } from '@angular/core'
import { MatIcon } from '@angular/material/icon'
import { MatSort, MatSortHeader } from '@angular/material/sort'
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
} from '@angular/material/table'
import { Router } from '@angular/router'
import {
  DataContextBuilder,
  ElderBasicPaneLayoutComponent,
  ElderDataToolbarComponent,
  ElderPaneComponent,
  ElderSearchBoxComponent,
  ElderSearchContextDirective,
  ElderTableComponent,
  ElderTableToolbarDirective,
  ElderToolbarContentDirective,
  IDataContext,
  Sort,
} from '@elderbyte/ngx-starter'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { Action } from '../action'
import { ActionService } from '../action.service'

@Component({
  selector: 'app-action-browser',
  templateUrl: './action-browser.component.html',
  styleUrls: ['./action-browser.component.scss'],
  imports: [
    ElderTableComponent,
    MatSort,
    ElderTableToolbarDirective,
    ElderDataToolbarComponent,
    ElderToolbarContentDirective,
    ElderSearchBoxComponent,
    ElderSearchContextDirective,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatIcon,
    MatSortHeader,
    DatePipe,
    ElderTranslatePipe,
    ElderBasicPaneLayoutComponent,
    ElderPaneComponent,
  ],
})
export class ActionBrowserComponent implements OnDestroy {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private router = inject(Router)
  public readonly data: IDataContext<Action>

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const operationService = inject(ActionService)
    this.data = DataContextBuilder.start<Action>()
      .pageSize(50)
      .reloadOnLocalChanges()
      .autoStartAsap([new Sort('createdAt', 'desc')])
      .build(operationService)
  }

  /***************************************************************************
   *                                                                         *
   * Life Cycle                                                              *
   *                                                                         *
   **************************************************************************/

  public ngOnDestroy(): void {
    if (this.data) {
      this.data.close()
    }
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public openSideDetail(action: Action): void {
    this.router.navigate([{ outlets: { side: ['process', 'actions', action.id] } }])
  }

  public create(): void {
    this.router.navigate([{ outlets: { side: ['process', 'actions', 'new'] } }])
  }
}
